import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { DateAdapter } from '@angular/material';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";
import {Observable} from "rxjs/Observable";
import * as _ from "lodash";
import * as XLSX from 'xlsx';
import csv from 'csv'

declare let swal:any;

@Component({
  selector: 'app-add-campaign',
  templateUrl: './add-campaign.component.html',
  styleUrls: ['./add-campaign.component.css']
})
export class AddCampaignComponent implements OnInit {

  errors: any = {};
  isLoading: boolean = false;

  targetName: string = '';
  targetFile:File;
  pharmaJSON: any = [];

  newChoiceSubmit: boolean = false;

  campaign: any = {
    name: '',
    type: '',
    start_date: "",
    end_date: "",
    formula: "",
    laboratories: [],
    contract: [],
    product: [],
    questions: [],
  };

  contractsList: any = [];
  productsList: any = [];

  curNewQuestion: any = {
    type: null,
    question: null,
    question_choices: []
  };

  newChoice: string = "";

  curQuestion: any = {
    type: null,
    question: null
  };

  @ViewChild('questionForm')
  questionFormVariable: any;

  possibleQuestion: any = [];

  questionTypes: any = [
    {type: 'string', value: 'Texte'},
    {type: 'number', value: 'Nombre'},
    {type: 'picture', value: 'Photo'},
    {type: 'select', value: 'Selection'},
    {type: 'checkbox', value: 'QCM'},
  ];

  environment: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('fr');
  }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });
    this.requestQuestions();
  }

  goBack() {
    this.router.navigate(['administration', 'campagnes']);
  }

  requestLaboratories = (text: string): Observable<Response> => {
    var query = "?search=" + text + "&limit=1000";
    return this.http.get(environment.API_PATH + '/laboratory' + query, {withCredentials: true})
	  .map(data =>  {
	    return data['rows']
    });
  };

  requestProducts = (text: string): Observable<Response> => {
    if (this.campaign.laboratories[0] && this.campaign.laboratories[0].id) {
      var query = "?search=" + text + "&labId=" + this.campaign.laboratories[0].id;
      return this.http.get(environment.API_PATH + '/product/active-product' + query, {withCredentials: true})
      .map(data =>  {
        return data['rows']
      });
    }
    else {
      this.errors.product = "Vous devez ajouter une promotion";
      return Observable.empty<Response>();
    }
  };

  addLabo(event) {
    delete this.errors.product;
    this.campaign.product = [];
    this.isLoading = true;
    var query = "?status=APPROVED&limit=1000&connectedAsId=" + event.id;

    this.http.get(environment.API_PATH + '/contract' + query, {withCredentials: true})
    .subscribe(
      data => {
        this.isLoading = false;
        this.contractsList = data['rows'];
        this.productsList = [];
      },
      err => {
        var errors = err.error;
        this.isLoading = false;
        if (errors.error) {
          if (errors.error.status === 401) {
            
            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
    this.valueChange('laboratories');
  }

  removeLabo(event) {
    this.campaign.contract = [];
    this.contractsList = [];
    this.campaign.product = [];
    this.valueChange('laboratories');
  }

  pharmaChange(files: any){
    var self = this;
    var fileReader = new FileReader();
    fileReader.onload = function (e) {

      var binary = "";
      var bytes = new Uint8Array(fileReader.result);
      var length = bytes.byteLength;
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      if (files[0].type === 'text/csv') {
        csv.parse(binary, { relax_column_count: true, columns: true, auto_parse_date: true, auto_parse: true }, function (err, data) {
          if (!err) {
            for (var i = 0; i < data.length; i++) {
              data[i] = _.mapKeys(data[i], function (v, k) {
                if (/(^|\s)cip($|\s)/gi.test(k)) {
                  return 'cip'
                } else if (/(^|\s)(nom|name)($|\s)/gi.test(k)) {
                  return 'nom'
                } else if (/(^|\s)(cp|code postal)($|\s)/gi.test(k)) {
                  return 'zipcode';
                } else {
                  return k.trim().toLowerCase();
                }
              });
            }
            for (var i = 0; i < data.length; i++) {
              if (!data[i].cip || !data[i].nom || !data[i].email) {
                data.splice(i, 1);
                i = 0;
              }
            }
          }
          self.pharmaJSON = _.cloneDeep(data);
        });
      }

      else {
        var oFile = XLSX.read(binary, {type: 'binary'});
        var dataJson = XLSX.utils.sheet_to_json(oFile.Sheets[oFile.SheetNames[0]], { raw: true });

        for (var i = 0; i < dataJson.length; i++) {
          dataJson[i] = _.mapKeys(dataJson[i], function (v, k) {
            if (/(^|\s)cip($|\s)/gi.test(k)) {
              return 'cip'
            } else if (/(^|\s)(nom|name)($|\s)/gi.test(k)) {
              return 'nom'
            } else if (/(^|\s)(cp|code postal)($|\s)/gi.test(k)) {
              return 'zipcode';
            } else {
              return k.trim().toLowerCase();
            }
          });
        }
        self.pharmaJSON = _.cloneDeep(dataJson);

      }

    };
    fileReader.readAsArrayBuffer(files[0]);

    this.targetName = files[0].name;
    this.targetFile = files[0];
  }


  requestQuestions() {
    this.isLoading = true;
    this.http.get(environment.API_PATH + '/question', {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.possibleQuestion = data;
      },
      err => {
        var errors = err.error;
        this.isLoading = false;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  matchingFn () {
    return true;
  }

  addQuestion() {
    if (!this.curNewQuestion.type || !this.curNewQuestion.question)
      return;

    if ((this.curNewQuestion.type === 'select' || this.curNewQuestion.type === 'checkbox') && this.curNewQuestion.question_choices.length <= 0)
      return;

    this.campaign.questions.push(_.cloneDeep(this.curNewQuestion));

    this.valueChange('questions');

    this.curNewQuestion.type = null;
    this.curNewQuestion.question = null;
    this.curNewQuestion.question_choices = [];

    for (var  i in this.questionFormVariable.controls) {
      this.questionFormVariable.controls[i].markAsUntouched();
      this.questionFormVariable.controls[i].reset();
    }
    this.questionFormVariable.submitted = false;
    this.questionFormVariable.reset();
  }

  addExistQuestion() {
    if (this.curQuestion.type == null || this.curQuestion.question == null)
      return;

    this.campaign.questions.push(this.curQuestion.question);
    this.valueChange('questions');
  }

  addChoice() {
    this.newChoiceSubmit = false;
    if (this.newChoice) {
      this.curNewQuestion.question_choices.push({value: this.newChoice});
      this.newChoice = "";
    }
    else {
      this.newChoiceSubmit = true;
    }
  }

  removeChoice(index) {
    this.curNewQuestion.question_choices.splice(index, 1);
  }

  removeQuestion(index) {
    this.campaign.questions.splice(index, 1);
  }

  changeQuestionType() {
    this.curQuestion.question = null;
  }

  changeNewQuestionType() {
    this.curNewQuestion.question = null;
    this.curNewQuestion.question_choices = [];
  }

  cancelSubmit() {
    this.router.navigate(['../..'], {relativeTo: this.route});
  }

  valueChange(field) {
    delete this.errors[field];
  }

  submitForm(form) {
    var flag = 0;
    this.errors = {};

    if (form.invalid)
      return;


    var formData = new FormData();
    formData.append('name', this.campaign.name);
    formData.append('type', this.campaign.type);
    formData.append('formula', this.campaign.formula);
    formData.append('start_date', this.campaign.start_date);
    formData.append('end_date', this.campaign.end_date);

    if (this.targetFile == undefined) {
      this.utilsService.displayNotif("Vous devez ajouter un fichier pharmacie", "danger");
      flag = 1;
    }
    else
      formData.append('target', this.targetFile);

    if (this.campaign.contract.length == 1)
      formData.append('contract_id', this.campaign.contract[0].id);

    if (this.campaign.product.length == 1)
      formData.append('product', JSON.stringify(this.campaign.product[0]));

    if (this.campaign.laboratories.length != 1) {
      this.utilsService.displayNotif("Vous devez ajouter un laboratoire", "danger");
      flag = 1;
    }
    else
      formData.append('laboratory_id', this.campaign.laboratories[0].id);

    if (this.campaign.questions.length == 0) {
      this.utilsService.displayNotif("Vous devez ajouter une question", "danger");
      flag = 1;
    }
    else
      formData.append('questions', JSON.stringify(this.campaign.questions));

    if (flag == 0 && !form.invalid) {
      this.isLoading = true;
      var data = _.cloneDeep(this.campaign);
      this.http.post(environment.API_PATH + '/campaign/add', formData, {withCredentials: true})
	    .subscribe(response => {
        this.isLoading = false;
        this.utilsService.displayNotif('La campagne a bien été créé', 'success');
        // this.router.navigate([this.router.url.split('/')[1], 'campagnes']);
      }, err => {
        this.isLoading = false;
        if (err.status === 401) {
          var errors = err.error;
          if (errors.error) {
            if (errors.error.status === 401) {

              this.router.navigate(['/connexion']);
            } else if (errors.error.status === 403) {
              if (errors.error.details.redirect)
                this.router.navigate([errors.error.details.redirect]);
              else if (errors.error.redirect) {
                this.router.navigate([errors.error.redirect]);
              }
              else
                this.authService.logout()
            } else {
              this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
            }
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else if (err.status == 400) {
          var details = err.error.error.details;
          if (!_.isEmpty(details)) {
            if ('general' in details) {
              for (var i in details.general) {
                this.utilsService.displayNotif(details.general[i], "danger");
              }
            }
            if ('field' in details) {
              for (var i in details.field) {
                this.errors[i] = details.field[i];
              }
            }
          }
        }
        else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/add-campaign/add-campaign.component.ts